<template>
  <div
    class="scan-dropzone"
    :class="{ 'scan-dropzone--active': isActive }"
    @dragover.prevent="isActive = true"
    @dragleave="isActive = false"
    @drop.prevent="onDrop"
    @click="input.click()"
  >
    <input
      ref="input"
      type="file"
      multiple
      accept=".png,.jpg,.jpeg,.pdf"
      style="display:none"
      @change="onChange"
    />
    <p>Перетащите файлы сюда или нажмите для выбора</p>
    <small>PNG, JPG, PDF до 20 МБ</small>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(['files'])
const input = ref(null)
const isActive = ref(false)

const onDrop = (e) => {
  isActive.value = false
  emit('files', [...e.dataTransfer.files])
}

const onChange = (e) => {
  emit('files', [...e.target.files])
  e.target.value = ''
}
</script>
